export interface PaidFeatureState {
}
export class PaidFeatureDto {
    genderChanges!: number;
    genderChangePrice!: number;
    renamePrice!: number;
}
